
import { login, loginOut } from '@/api/interface/user'
const app = {
  state: {
    userInfo: null,
    isMobile: false,
    timeDiff: 0,
    uploadParams: null,
    device: null,
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    publishStatus: 0,
    shareTitle: {},
    shareList: {
      indexM: '“对话历史·美育未来”青少年美育专题活动',
      indexF: '以美育人、以美化人、以美培元',
      newsM: '活动快讯 |“对话历史·美育未来”青少年美育专题活动',
      newsF: '速来了解关于美育活动的最新动态吧~',
      newsDetail: '对话历史·美育未来·活动快讯',
      zacwlistM: '全民美育 |“对话历史·美育未来”青少年美育专题活动',
      zacwlistF: '逐梦向未来·唱响新时代',
      sjcwlistM:'美育课堂 |“对话历史·美育未来”青少年美育专题活动',
      sjcwlistF:'启智润心·培根铸魂',
      dnkcM: '大唐西市 |“对话历史·美育未来”青少年美育专题活动',
      dnkcwF: '对话历史·美育未来',
      dysjM: '多元实践 |“对话历史·美育未来”青少年美育专题活动',
      dysjF: '多彩美育·融入生活',
      resultM: '',
      resultF: '',
      imgUrl: require('../../assets/img/shareicon.png'),
      videoUrl: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/4-美育宣传片.mp4',
      coverUrl:'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/4-美育未来.png'


    },
    operate: {
      operateCode:'a46344bc-cd24-4cb1-8d83-473d11167d9c',  // 大唐西市
      news: '43dfd68b-f95f-3f5c-fbd0-3e0b57d3f9c5-news', //	活动快讯
      likeHistory: '43dfd68b-f95f-3f5c-fbd0-3e0b57d3f9c5-like-history', //	 文明探源
      like23: '43dfd68b-f95f-3f5c-fbd0-3e0b57d3f9c5-like-2023', //	 非遗 传承
      tidbits: '43dfd68b-f95f-3f5c-fbd0-3e0b57d3f9c5-tidbits', // 多元实践 
    },
    infoList: {
      sjcw: '为深入学习宣传贯彻党的二十大精神、全面推进乡村文化振兴、推动公共文化服务高质量发展，特此开展“四季村晚”活动。通过开展春季、夏季、秋季、冬季“村晚”活动，推动“村晚”活动常态化开展，展示各地乡村丰富多彩群众文化活动，呈现乡村振兴的丰硕成果，促进文旅融合，推进移风易俗，树立文明乡风，激发新时代乡村振兴的文化活力。',
      zajm1: '陕西省文化馆“四季村晚”系列活动之“我最爱的村晚节目”，精选一批陕西省近年来（2021年度、2022年度）农民群众自编自导自演的“村晚”精彩节目，展开线上展示及点赞。',
      zajm2: '同时，针对2023年度短视频征集，开展线上网络投票，最终推选出10个优秀节目并发布榜单，在主流媒体进行宣推，并收录至全民艺术普及资源总库。快来一键参与，为你最喜爱的“村晚”节目助力吧！',
      zajm3: '1、投票时段：待2023年短视频征集后集中发起；',
      zajm4: ' 2、每个用户可为多个短视频作品投票；',
      zajm5: ' 3、每个用户每天对同一作品可投5票。',
      dnkcw1: '家门口的大联欢！',
      dnkcw2: '带你探寻“村晚”节目背后的故事，浓浓家乡味，美丽新乡村。',
      dnkcw3: '多维呈现村晚故事，感受村晚现场氛围。',
      wlzq1: '将村里的故事讲给你听。',
      wlzq2: '倾听文旅小故事，领略文旅好风光。',
      wlzq3: '融合乡土文化、乡村旅游，呈现农民精神新风貌、乡村振兴新气象。'
    },
    fourList: [],
    ewmList: [
      { title: '微信公众号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wx.png'), ewm: require('../../assets/img/wx.jpg') },
      { title: '视频号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/sph.png'), ewm: require('../../assets/img/sphs.jpg') },
      { title: '官方微博', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wb.png'), ewm: require('../../assets/img/wb.png') },
      { title: 'bilibili 哔哩哔哩', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/B.png'), ewm: require('../../assets/img/bz.png') },
      { title: '官方抖音', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/dy.png'), ewm: require('../../assets/img/dy.jpg') }
      // { title: '快手（认证中）', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/ks.png'), ewm: null },
    ],
    youList: [
      { cover: require('../../assets/img/sjcw/logo1.png'), path: 'http://whhlyt.shaanxi.gov.cn/' },
      { cover: require('../../assets/img/sjcw/logo2.png'), path: 'http://sxswhg.org.cn/' },
      { cover: require('../../assets/img/sjcw/logo3.png'), path: 'http://www.sxggwhy.com/' }
    ]

  },

  mutations: {
    SET_FOURLIST: (state, fourList) => {
      state.fourList = fourList
    },
    SET_PUBLISHOVER: (state, publishStatus) => {
      state.publishStatus = publishStatus
    },
    SET_SHARELIST: (state, shareList) => {
      state.shareList = shareList
    },
    SET_SHARETITLE: (state, shareTitle) => {
      state.shareTitle = shareTitle
    },
    SET_OPERATECODE: (state, operateCode) => {
      state.operateCode = operateCode
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_POSITION: (state, position) => {
      state.position.latitude = position.latitude
      state.position.longitude = position.longitude
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_UPLOADPARAMS: (state, uploadParams) => {
      state.uploadParams = uploadParams
    },
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_USERINFOLOGIN: (state, userinfologin) => {
      state.userinfologin = userinfologin
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { userCode, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userCode: userCode.trim(), password: password }).then(response => {
          const { data } = response
          commit('SET_USERINFOLOGIN', response.data.data.list[0].user)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFOLOGIN', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js